import { ReactNode, useState } from "react";
import Icon from "../Icon";
import SideSheetModal from "../SideSheetModal/SideSheetModal";
import Button from "../Button";
import Badge from "../Badge";

type MenuProps = {
  content: ReactNode;
  activeFilters?: number;
  useIsOpen?: boolean;
};

export default function MenuFilters({ content, activeFilters, useIsOpen = false }: MenuProps) {
  const [isOpen, setIsOpen] = useState(useIsOpen);

  return (
    <div>
      <div role="button" onClick={() => setIsOpen(!isOpen)} data-testid="expanded-filters-button" className="w-fit">
        <div className="w-10 h-10 sm:w-fit sm:h-auto sm:border border-sys-brand-outline sm:py-4 sm:px-4 flex items-center justify-center rounded relative">
          {activeFilters && activeFilters > 0 ? (
            <Badge color="primary" value={activeFilters} className="absolute -right-1.5 -top-1.5" />
          ) : null}
          <Icon name="filter_alt" size={24} className="text-sys-brand-on-surface sm:mr-2" />
          <span className="hidden sm:block">Filters</span>
        </div>
      </div>

      <SideSheetModal
        isSidebarOpen={isOpen}
        title={"Filters"}
        setSidebarOpen={setIsOpen}
        actions={<Button onClick={() => setIsOpen(false)}>View Results</Button>}
      >
        {content}
      </SideSheetModal>
    </div>
  );
}
